import { distanceNm } from "@/utils/geo";

// Soglia di "raggiungimento" del naufrago: 0.1 NM (~185 m).
export const REACH_NM = 0.1;

const ms = (p) => (p && p.ts ? Date.parse(p.ts) : NaN);

// Posizione del naufrago al tempo t (ultimo punto con ts <= t, altrimenti il primo).
function victimAt(track, t) {
  let pos = track[0];
  for (const p of track) {
    const pt = ms(p);
    if (!Number.isFinite(pt) || pt <= t) pos = p; else break;
  }
  return pos;
}

// Tempo intervento della motovedetta: dall'assegnazione (primo punto mv_track)
// al primo punto entro REACH_NM dal naufrago. null se nessuna motovedetta.
export function interventionTime(ev) {
  const mv = ev?.mv_track || [];
  const track = ev?.track || [];
  if (!mv.length || !track.length) return null;
  const startMs = ms(mv[0]);
  let minNm = Infinity;
  for (const p of mv) {
    const t = ms(p);
    const v = victimAt(track, Number.isFinite(t) ? t : Infinity);
    const d = distanceNm(p.lat, p.lng, v.lat, v.lng);
    if (d < minNm) minNm = d;
    if (d <= REACH_NM) {
      const seconds = Number.isFinite(startMs) && Number.isFinite(t) ? Math.max(0, Math.round((t - startMs) / 1000)) : null;
      return { reached: true, startTs: mv[0].ts, reachedTs: p.ts, seconds, minNm: d };
    }
  }
  return { reached: false, startTs: mv[0].ts, reachedTs: null, seconds: null, minNm };
}

export function fmtIntervention(seconds) {
  if (seconds == null) return "—";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const p2 = (n) => String(n).padStart(2, "0");
  return h ? `${h}:${p2(m)}:${p2(s)}` : `${p2(m)}:${p2(s)}`;
}
